import React, { useState, Component, useEffect } from 'react';
import { connect } from 'react-redux'
import * as actions from '@/models/orders/actions'
import * as services from '@/models/orders/services';
import cn from 'classnames';
import { Modal, Form, Avatar, Button, Select, Input, Popconfirm, message, InputNumber, Tabs, Table } from 'antd';
import styles from './styles.module.less';
import EditTable from "../EditTable.jsx";
import * as apis from '@/apis'
const tenantMode = process.env.APP_MODE === 'tenant';

function Member(props) {
  const { children, order, form, tenant } = props
  const { getFieldDecorator, validateFields, getFieldValue } = form;

  const [showDialog, toggleDialog] = useState(false);
  const [tenantList, setTenantList] = useState([]);
  const [activeTenant, setActiveTenant] = useState(0);
  const [managerList, setManagerList] = useState([]);
  const [activeManager, setActiveManage] = useState(0);
  const [activeKey, setActiveKey] = useState(1);

  const columns = [
    {
      title: '群成员',
      dataIndex: 'user',
      key: 'user',
      render: user => <span className={styles.priceName}>
        <Avatar size="small" className={styles.avatar}
          src={user?.avatar}></Avatar>
        {user?.name}</span>,
    },
    {
      title: '电话',
      key: 'userMobile',
      render: item => <span>{item?.user?.mobile}</span>,
    },
    {
      title: '是否在线',
      //dataIndex: 'expressNo',
      key: 'expressNo',
      render: item => <a style={{ color: item?.user?.is_online ? '' : '#999' }}>{item?.user?.is_online ? '在线' : '离线'}</a>
    },
    {
      title: '备注（双击修改）',
      dataIndex: 'remark',
      key: 'remark',
      editable: true,
      display: tenantMode ? false : true,
      // render: (text, item) => <span>{item?.user?.remark}</span>
    },
  ].filter((item) => item.display !== false);

  const managerColumns = [
    {
      title: '群成员',
      dataIndex: 'user',
      key: 'user',
      width: 200,
      render: user => <span className={styles.priceName}>
        <Avatar size="small" src={user?.avatar} style={{ marginRight: '10px' }}></Avatar>
        {user?.name}</span>,
    },
    {
      title: '电话',
      key: 'userMobile',
      render: item => <span>{item?.user?.mobile}</span>,
    },
    {
      title: '是否在线',
      key: 'expressNo',
      render: item => <a style={{ color: item?.user?.is_online ? '' : '#999' }}>{item?.user?.is_online ? '在线' : '离线'}</a>
    },
    {
      title: '备注',
      dataIndex: 'ext',
      key: 'ext',
      display: tenantMode ? false : true,
    },
  ].filter((item) => item.display !== false);

  const initData = () => {
    getTenantsStaff()
    getManagersCustom()
  }
  const getTenantsStaff = () => {
    services.getTenantsStaff({ tenant: tenant?.get('_id') }).then(res => {
      let list = (res.data || [])?.map(val => {
        return {
          ...val,
          remark: val?.user?.remark
        }
      })
      const aList = list.filter(item => item?.user?.is_online)
      setActiveTenant(aList.length)
      setTenantList(list);
    })
  }
  const getManagersCustom = () => {
    services.getManagersCustom({ tenant: tenant?.get('_id') }).then(res => {
      let list = res.data || []
      const aList = list.filter(item => item?.user?.is_online)
      setActiveManage(aList.length)
      setManagerList(list);
    })
  }

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      let reason = values.guaqi_reason
      if (values.cancel_memo) {
        reason += ' - ' + values.cancel_memo
      }

      // services.orderGuaqi({ orderId: order.get('_id'), guaqi_reason: reason }).then(result => {
      //   message.success('提交成功')
      //   toggleDialog(false)
      //   typeof change === 'function' && change()
      // }).catch(err => {
      //   message.error(err.message || '发生错误')
      // }).finally(() => {
      // })
    });
  }

  const setMystaffUpdate = async (params = {}) => {
    return await apis.mystaffUpdate(params)
  }

  // dataSource 本次修改的信息
  // newData 完整的表格信息
  const handleTenantClick = async ({ dataSource, newData }) => {
    await setMystaffUpdate({
      user_id: dataSource?.user?._id,
      remark: dataSource?.remark
    }).then(res => {
      getTenantsStaff()
    })
  }

  useEffect(() => {
    if (showDialog) {
      initData()
    }
  }, [showDialog])

  return (
    <React.Fragment>
      {
        React.isValidElement(children) && React.cloneElement(children, {
          onClick: toggleDialog,
        })
      }
      <Modal
        title="成员列表"
        destroyOnClose

        width={580}
        visible={!!showDialog}
        // onOk={() => { handleSubmit() }}
        onOk={() => { toggleDialog(false) }}
        onCancel={() => toggleDialog(false)}
        bodyStyle={{ padding: '0 10px 10px' }}
      >
        <Tabs
          defaultActiveKey="1"
          tabBarExtraContent={<span>在线/全部：{activeKey == 1 ? activeTenant : activeManager}/{activeKey == 1 ? tenantList.length : managerList.length}</span>}
          onChange={(key) => {
            setActiveKey(key)
          }}>
          <Tabs.TabPane tab="商家成员" key={1}>
            <EditTable
              rowKey="_id"
              dataSource={tenantList}
              columns={columns}
              handleClickdata={handleTenantClick}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="客服成员" key={2}>
            <Table rowKey="_id" size="small" bordered={false} columns={managerColumns} dataSource={managerList}
              pagination={false}
              scroll={{ y: '300px' }} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </React.Fragment>
  );
}


export default connect()(Form.create()(Member))